<script lang="ts">
	//Hooks
	import { slide } from 'svelte/transition';
	//Formatters
	import { format } from 'svelte-i18n';
	//Design system components
	import { Checkbox, Stack, Text } from '@Shelly/shelly-design-system/index';
	//Types
	import type { SensorScanComponent, SensorScanResult, SensorType } from 'src/types/Peripherals';

	export let peripheralScanResult: SensorScanResult,
		selectedSensorComponent: SensorScanComponent,
		selectedSensorType: SensorType;

	const isSelected = (channel: number, selectedSensorComponent: SensorScanComponent): boolean => {
		return !peripheralScanResult?.disabled && selectedSensorComponent?.io === channel;
	};

	const isIOUsed = (channel: number, selectedSensorType: SensorType): boolean => {
		return (
			selectedSensorType === peripheralScanResult?.sensorType &&
			(peripheralScanResult?.peripherals || []).find((per) => per.io === channel) != null
		);
	};

	const buildPeripheralLabel = (channel: number): string => {
		let label = `${$format('label_io_channel', {
			default: 'Channel',
		})} ${channel}`;
		if (isIOUsed(channel, selectedSensorType)) {
			label += ` - ${$format('label_slot_unavailable', {
				default: 'Slot unavailable',
			})}`;
		}
		return label;
	};
</script>

<div style="padding-left: 36px;">
	<Stack gap="s">
		<Text class="width-full text-bold" styleType="body-small">
			{$format('label_select_sensor_channel', {
				default: `Select sensor channel:`,
			})}
		</Text>
		{#each [0, 1] as channel}
			<div transition:slide={{ duration: 500 }}>
				<Checkbox
					size="m"
					id="sensor-channel-{channel}"
					checked={isSelected(channel, selectedSensorComponent)}
					on:click={(e) => {
						e.preventDefault();
						selectedSensorComponent = { io: channel };
					}}
					disabled={isIOUsed(channel, selectedSensorType)}
				>
					{buildPeripheralLabel(channel)}
				</Checkbox>
			</div>
		{/each}
	</Stack>
</div>
